<template>
    <v-content>
        <v-app>
            <v-container grid-list-xl text-xs-center fluid class="container-transactions">
                <v-layout row wrap>
                    <v-flex xs4 sm4 d-flex>
                        <v-select v-model="defaultSelect" :items="merchant" @change="getReport()" item-text="name" item-value="uuid" label="Companies"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.holder" append-icon="search" label="Card Holder" clearable @click:clear="resetFilter(search.holder)" @keyup.enter="getReport"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.merchantTransactionId" append-icon="search" label="Merchant Transaction ID" clearable @click:clear="resetFilter(search.merchantTransactionId)" @keyup.enter="getReport"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="search.status" dense :items="statusOptions" label="Status" append-icon="search" @change="getReport"></v-select>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs2 text-xs-right>
                        <v-btn class="downloadBtn" v-if="!download" color="primary" fab small dark @click="downloadReport(); download = true;">
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                        <v-progress-circular v-else class="downloadProgress" indeterminate color="primary"></v-progress-circular>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs12>
                        <v-data-table id="transactions-table" :headers="tableHeaders" :items="report" :loading="loading" :rows-per-page-items="rowsPerPage" class="elevation-1">
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-center">{{ props.item.processingTime }}</td>
                                <td class="text-xs-center">{{ props.item.holder }}</td>
                                <td class="text-xs-center">{{ props.item.merchantTransactionId }}</td>
                                <td class="text-xs-center">{{ props.item.bin }}</td>
                                <td class="text-xs-center">{{ props.item.last4Digits }}</td>
                                <td class="text-xs-center">{{ props.item.expiryDate }}</td>
                                <td class="text-xs-center">{{ props.item.expiryStatus }}</td>
                                <td class="text-xs-center">{{ props.item.uuid }}</td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
    import axios from 'axios';
    import moment from 'moment';

    export default {
        data() {
            return {
                tableHeaders: [ { text: 'Registration Date', value: 'processingTime', sortable: false, align: "center" },
                                { text: 'Card Holder', value: 'holder', sortable: false, align: "center" },
                                { text: 'Merchant Transaction ID', sortable: false, align: "center" },
                                { text: 'BIN', sortable: false, align: "center" },
                                { text: 'Last 4 Digits', sortable: false, align: "center" },
                                { text: 'Expiration Date', value: "expiryDate", sortable: false, align: "center" },
                                { text: 'Status', sortable: false, align: "center" },
                                { text: 'Registration ID', sortable: false, align: "center" }],
                report: [],
                loading: true,
                rowsPerPage:[10, 25, 50, 100],
                search: { holder: null, 
                          merchantTransactionId: null,
                          status: null },
                statusOptions: [
                            { value: null, text: "All" },
                            { value: 'Due To Expire', text: "Due To Expire" },
                            { value: 'Expired', text: "Expired" }],
                download: false,
                merchant: null,
                merchantId: null,
                defaultSelect: null
            }
        },
        beforeMount() {
            this.getMerchants();
        },
        methods: {
            getReport() {
                this.loading = true;
                this.merchantId = typeof this.defaultSelect == 'object' ? this.merchantId : this.defaultSelect;

                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-expired-cards-report',
                data: { merchantUuid: this.merchantId, search: this.search },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.report = response.data;
                    this.loading = false;
                    
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getMerchants() {
                axios({
                method: 'post',
                data: { userId: localStorage.user_id },
                url: 'https://controlapi.totalprocessing.com/api/client-get-merchant',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchant = response.data;
                    this.defaultSelect = this.merchant[0];
                    this.merchantId = this.merchant[0].uuid;
                    this.getReport();
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            resetFilter(field) {              
                this.field = null;
                this.getReport();
            },
            downloadReport() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-expired-cards-pdf',  
                data: { merchantUuid: this.merchantId, search: this.search },              
                responseType: 'blob',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'expired-cards-report.csv');
                    document.body.appendChild(link);
                    link.click();
                    this.download = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
        }
    }
</script>

<style scoped>
    .downloadBtn, .downloadProgress {
        width: 36px !important;
        height: 36px !important;
        margin-top: 13px !important;
    }
</style>